module.exports = __webpack_public_path__ + "static/media/rocket.05ba26a8.webp";